module.exports = __webpack_public_path__ + "media/images/fondo-ed9775b41fd037ec7f489035e0cae363.jpg";